import { gql } from "@apollo/client";

export const CREATE_COMPANY_BANK_ACCOUNT = gql`
  mutation createCompanyBankAccount($input: CreateCompanyBankAccountInput!) {
    createCompanyBankAccount(input: $input) {
      errors {
        field
        messages
      }
    }
  }
`;

export const UPDATE_COMPANY_BANK_ACCOUNT = gql`
  mutation updateCompanyBankAccount($input: UpdateCompanyBankAccountInput!) {
    updateCompanyBankAccount(input: $input) {
      errors {
        field
        messages
      }
    }
  }
`;
export const CREATE_BANK = gql`
  mutation createBank($input: CreateBankInput!) {
    createBank(input: $input) {
      errors {
        field
        messages
      }
    }
  }
`;

export const UPDATE_BANK = gql`
  mutation updateBank($input: UpdateBankInput!) {
    updateBank(input: $input) {
      errors {
        field
        messages
      }
    }
  }
`;

export const GET_COMPANY_BANK_ACCOUNT = gql`
  query getCompanyBankAccount($id: ID!) {
    getCompanyBankAccount(id: $id) {
      bic
      iban
      id
      isActive
      name
      isMain
      bankDescription
      sepaCredentialIdentifier
      bank {
        id
      }
      currency
      integration
    }
  }
`;

export const GET_BANK = gql`
  query getBank($id: ID!) {
    getBank(id: $id) {
      id
      name
    }
  }
`;
